import { useState, useEffect } from "react";
import "../assets/CPResource.css";
import '../assets/dhayaricpkit.css';

import dhayari_bg from '../assets/imgs/Banner/dhayari_bg.jpeg';
import d2 from '../assets/imgs/d1.jpeg';
import d3 from '../assets/imgs/d2.jpeg';
import d4 from '../assets/imgs/d3.jpeg';
import d5 from '../assets/imgs/d4.jpeg';

export default function DhayariCpKit() {
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({ name: "", mobile: "" });
    const [isUnlocked, setIsUnlocked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        if (isUnlocked) {
            setTimeout(() => setShowPopup(true), 1000);
        }
    }, [isUnlocked]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        if (!formData.name || !formData.mobile) {
            return alert("Please fill all fields");
        }

        if (!/^[0-9]{10}$/.test(formData.mobile)) {
            return alert("Enter valid 10 digit mobile number");
        }

        setLoading(true);

        try {
            const res = await fetch(
                "https://samriddhidevelopers.in/backend/save_dhayari_cp.php",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(formData),
                }
            );

            const data = await res.json();

            if (data.status === "success") {
                setIsUnlocked(true);
            } else {
                alert(data.message || "Something went wrong");
            }
        } catch (err) {
            console.error(err);
            alert("Server error");
        }

        setLoading(false);
    };

    return (
        <div className="container">

            {/* HERO */}
            {!isUnlocked && (
                <div className="d-hero">
                    <div className="overlay">
                        <h1>Dhayari Elite Homes</h1>
                        <p>1 & 2 BHK</p>

                        {!showForm ? (
                            <button className="btn-primary" onClick={() => setShowForm(true)}>
                                Access CP Materials
                            </button>
                        ) : (
                            <div className="form-box">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Name"
                                    className="input"
                                    onChange={handleChange}
                                />
                                <input
                                    type="text"
                                    name="mobile"
                                    placeholder="Mobile Number"
                                    className="input"
                                    onChange={handleChange}
                                />
                                <button
                                    className="btn-secondary"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Please wait..." : "Unlock Access"}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* IMAGE STRIP */}
            {!isUnlocked && (
                <div className="image-strip">
                    <img src={dhayari_bg} alt="" />

                    <img src={d2} alt="" />
                    <img src={d3} alt="" />
                    <img src={d4} alt="" />
                </div>
            )}

            {/* DASHBOARD */}
            {isUnlocked && (
                <div className="dashboard">
                    <div className="dashboard-inner">
                        <h1 className="dashboard-title">
                            Prime Dhayari Homes
                        </h1>

                        <p className="dashboard-sub">
                            Everything you need to close deals is below
                        </p>

                        <div className="grid">
                            <a href="https://drive.google.com/drive/folders/1neIMUHQ-Vi0_GhDrx8AvHa5Y69nE7bjO?usp=drive_link" target="_blank" className="card">📘 Brochure</a>
                            <a href="https://drive.google.com/drive/folders/1YRDyb0VyoTSEPFq1oyBjNwDQ7LuBdgdB?usp=drive_link" target="_blank" className="card">🗺 Layout</a>
                            <a href="https://drive.google.com/drive/folders/1xfsICbNpG9hIHWC1_uPGm0FW_lW7Xfpy?usp=drive_link" target="_blank" className="card">🎥 Videos</a>
                            <a href="https://drive.google.com/drive/folders/13ayxISicXToQwGUzy7s6ShPuVI2Z8HE0?usp=drive_link" target="_blank" className="card">📄 Price Sheet</a>
                            <a href="https://drive.google.com/drive/folders/1H46iKj1_ps66Eo0f7Go9V3v5KmPSep2H?usp=drive_link" target="_blank" className="card">📢 Creatives</a>

                        </div>
                    </div>
                </div>
            )}

            {/* POPUP */}
            {showPopup && (
                <div className="popup">
                    <p>Need help closing a deal?</p>
                    <a href="tel:9730050099">Contact Sales Team</a>
                </div>
            )}
        </div>
    );
}